(function () {
  const addToCartSelectors = [
    'button[name="add"]',
    '.product-form__submit',
    'form[action*="/cart/add"] button[type="submit"]'
  ];

  const buyNowSelectors = [
    '.shopify-payment-button__button',
    '.shopify-payment-button button',
    '.shopify-payment-button [role="button"]'
  ];

  const effects = {
    add: {
      key: 'add',
      hostClass: 'atc-bubble-splash',
      directions: ['left', 'up', 'right'],
      inwardClass: 'is-add-inward',
      hoverBurstClass: 'is-add-green-burst',
      normalSeedAmount: 16,
      hoverSeedAmount: 22,
      normalSeedSpacing: 55,
      hoverSeedSpacing: 18,
      normalInterval: 120,
      hoverInterval: 55
    },

    buy: {
      key: 'buy',
      hostClass: 'buy-bubble-splash',
      directions: ['left', 'down', 'right'],
      baseBubbleClass: 'is-buy-bubble',
      inwardClass: 'is-buy-inward',
      hoverBurstClass: 'is-buy-blue-burst',
      normalSeedAmount: 16,
      hoverSeedAmount: 22,
      normalSeedSpacing: 55,
      hoverSeedSpacing: 18,
      normalInterval: 120,
      hoverInterval: 55
    }
  };

  function randomBetween(min, max) {
    if (max < min) {
      const temporary = min;
      min = max;
      max = temporary;
    }

    return min + Math.random() * (max - min);
  }

  function getRandomDirection(effect) {
    return effect.directions[Math.floor(Math.random() * effect.directions.length)];
  }

  function getEdgeCoordinates(direction, mode, halfWidth, halfHeight) {
    const xInset = Math.min(28, Math.max(8, halfWidth * 0.16));
    const yInset = Math.min(8, Math.max(4, halfHeight * 0.18));

    let startX;
    let startY;
    let endX;
    let endY;

    if (mode === 'out') {
      if (direction === 'up') {
        startX = randomBetween(-halfWidth + xInset, halfWidth - xInset);
        startY = -halfHeight - randomBetween(1, 5);

        endX = startX + randomBetween(-16, 16);
        endY = startY - randomBetween(18, 38);
      }

      if (direction === 'right') {
        startX = halfWidth + randomBetween(1, 6);
        startY = randomBetween(-halfHeight + yInset, halfHeight - yInset);

        endX = startX + randomBetween(18, 42);
        endY = startY + randomBetween(-14, 14);
      }

      if (direction === 'down') {
        startX = randomBetween(-halfWidth + xInset, halfWidth - xInset);
        startY = halfHeight + randomBetween(1, 5);

        endX = startX + randomBetween(-16, 16);
        endY = startY + randomBetween(18, 38);
      }

      if (direction === 'left') {
        startX = -halfWidth - randomBetween(1, 6);
        startY = randomBetween(-halfHeight + yInset, halfHeight - yInset);

        endX = startX - randomBetween(18, 42);
        endY = startY + randomBetween(-14, 14);
      }
    } else {
      if (direction === 'up') {
        endX = randomBetween(-halfWidth + xInset, halfWidth - xInset);
        endY = -halfHeight - randomBetween(1, 5);

        startX = endX + randomBetween(-16, 16);
        startY = endY - randomBetween(22, 42);
      }

      if (direction === 'right') {
        endX = halfWidth + randomBetween(1, 6);
        endY = randomBetween(-halfHeight + yInset, halfHeight - yInset);

        startX = endX + randomBetween(22, 46);
        startY = endY + randomBetween(-14, 14);
      }

      if (direction === 'down') {
        endX = randomBetween(-halfWidth + xInset, halfWidth - xInset);
        endY = halfHeight + randomBetween(1, 5);

        startX = endX + randomBetween(-16, 16);
        startY = endY + randomBetween(22, 42);
      }

      if (direction === 'left') {
        endX = -halfWidth - randomBetween(1, 6);
        endY = randomBetween(-halfHeight + yInset, halfHeight - yInset);

        startX = endX - randomBetween(22, 46);
        startY = endY + randomBetween(-14, 14);
      }
    }

    return {
      startX: startX,
      startY: startY,
      endX: endX,
      endY: endY
    };
  }

  function getBurstCoordinates(effect, buttonWidth, buttonHeight) {
    const direction = getRandomDirection(effect);
    const distance = randomBetween(55, 95);

    const startX = randomBetween(-buttonWidth * 0.16, buttonWidth * 0.16);
    const startY = randomBetween(-buttonHeight * 0.16, buttonHeight * 0.16);

    let endX = 0;
    let endY = 0;

    if (direction === 'up') {
      endX = randomBetween(-35, 35);
      endY = -distance;
    }

    if (direction === 'right') {
      endX = distance;
      endY = randomBetween(-28, 28);
    }

    if (direction === 'down') {
      endX = randomBetween(-35, 35);
      endY = distance;
    }

    if (direction === 'left') {
      endX = -distance;
      endY = randomBetween(-28, 28);
    }

    return {
      startX: startX,
      startY: startY,
      endX: endX,
      endY: endY
    };
  }

  function setupBubbleEffect(host, effect) {
    if (!host || host.dataset.zellartBubbleEffectReady) return;

    host.dataset.zellartBubbleEffectReady = effect.key;
    host.classList.add(effect.hostClass);

    let stopped = false;
    let isHovering = false;
    let ambientTimer = null;
    let streamId = 0;

    let lastPointerType = 'mouse';
    let mobileBurstTimer = null;

    let touchHoldActive = false;
    let touchLeaveTimer = null;
    let touchHoldFallbackTimer = null;

    function clearAmbientBubbles() {
      host.querySelectorAll('.atc-bubble:not(.is-burst)').forEach(function (bubble) {
        bubble.remove();
      });
    }

    function makeBubble(options = {}) {
      const burst = options.burst === true;
      const mode = options.mode || (isHovering ? 'in' : 'out');
      const immediate = options.immediate === true;

      if (stopped && !burst) return;

      const bubble = document.createElement('span');
      bubble.className = 'atc-bubble';

      if (effect.baseBubbleClass) {
        bubble.classList.add(effect.baseBubbleClass);
      }

      if (mode === 'in' && !burst) {
        bubble.classList.add(effect.inwardClass);
      }

      if (burst) {
        bubble.classList.add('is-burst');

        if (isHovering || lastPointerType !== 'mouse') {
          bubble.classList.add(effect.hoverBurstClass);
        }
      }

      const buttonWidth = host.offsetWidth || 420;
      const buttonHeight = host.offsetHeight || 48;

      const halfWidth = buttonWidth / 2;
      const halfHeight = buttonHeight / 2;

      const bubbleSize = burst
        ? randomBetween(5, 14)
        : randomBetween(4, 12);

      const coordinates = burst
        ? getBurstCoordinates(effect, buttonWidth, buttonHeight)
        : getEdgeCoordinates(
            getRandomDirection(effect),
            mode,
            halfWidth,
            halfHeight
          );

      const duration = burst
        ? 620
        : mode === 'in'
          ? randomBetween(400, 680)
          : randomBetween(1200, 2050);

      bubble.style.setProperty('--start-x', `${coordinates.startX}px`);
      bubble.style.setProperty('--start-y', `${coordinates.startY}px`);
      bubble.style.setProperty('--end-x', `${coordinates.endX}px`);
      bubble.style.setProperty('--end-y', `${coordinates.endY}px`);
      bubble.style.setProperty('--size', `${bubbleSize}px`);
      bubble.style.setProperty('--duration', `${duration}ms`);
      bubble.style.setProperty('--delay', `${immediate || burst ? 0 : randomBetween(0, 70)}ms`);

      host.appendChild(bubble);

      bubble.addEventListener('animationend', function () {
        bubble.remove();
      });
    }

    function startStream(mode) {
      if (stopped) return;

      streamId += 1;

      const currentStream = streamId;

      clearInterval(ambientTimer);
      clearAmbientBubbles();

      const seedAmount = mode === 'in' ? effect.hoverSeedAmount : effect.normalSeedAmount;
      const seedSpacing = mode === 'in' ? effect.hoverSeedSpacing : effect.normalSeedSpacing;
      const intervalSpeed = mode === 'in' ? effect.hoverInterval : effect.normalInterval;

      for (let i = 0; i < seedAmount; i++) {
        setTimeout(function () {
          if (stopped || currentStream !== streamId) return;

          makeBubble({
            mode: mode,
            immediate: true
          });
        }, i * seedSpacing);
      }

      ambientTimer = setInterval(function () {
        if (stopped || currentStream !== streamId) return;

        makeBubble({ mode: mode });

        if (Math.random() > 0.35) {
          makeBubble({ mode: mode });
        }
      }, intervalSpeed);
    }

    function enterInwardState() {
      if (stopped || isHovering) return;

      isHovering = true;
      host.classList.add('is-hovering');

      startStream('in');
    }

    function leaveInwardState() {
      if (stopped || !isHovering || touchHoldActive) return;

      isHovering = false;
      host.classList.remove('is-hovering');

      startStream('out');
    }

    function keepTouchHoldAlive() {
      if (stopped || !touchHoldActive) return;

      clearTimeout(touchHoldFallbackTimer);

      touchHoldFallbackTimer = setTimeout(function () {
        if (stopped) return;

        touchHoldActive = false;
        leaveInwardState();
      }, 8000);
    }

    function beginTouchHold() {
      if (stopped) return;

      lastPointerType = 'touch';
      touchHoldActive = true;

      clearTimeout(touchLeaveTimer);
      clearTimeout(touchHoldFallbackTimer);

      enterInwardState();
      keepTouchHoldAlive();
    }

    function finishTouchHold() {
      if (lastPointerType === 'mouse') return;

      touchHoldActive = false;

      clearTimeout(touchHoldFallbackTimer);
      clearTimeout(touchLeaveTimer);

      touchLeaveTimer = setTimeout(function () {
        if (stopped) return;

        leaveInwardState();
      }, 900);
    }

    function burstAndStop() {
      if (stopped) return;

      stopped = true;
      streamId += 1;
      touchHoldActive = false;

      clearTimeout(mobileBurstTimer);
      clearTimeout(touchLeaveTimer);
      clearTimeout(touchHoldFallbackTimer);
      clearInterval(ambientTimer);

      clearAmbientBubbles();

      for (let i = 0; i < 34; i++) {
        setTimeout(function () {
          makeBubble({ burst: true });
        }, Math.random() * 55);
      }
    }

    /* Desktop hover */
    host.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;

      lastPointerType = 'mouse';
      enterInwardState();
    });

    host.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'mouse') return;

      leaveInwardState();
    });

    /*
      Mobile/touch hold.
      This starts the inward state immediately on finger touch.
    */
    host.addEventListener('touchstart', function () {
      beginTouchHold();
    }, { passive: true });

    /*
      Some browsers fire pointerdown before touchstart,
      some after. This catches tablets/pens as well.
    */
    host.addEventListener('pointerdown', function (event) {
      lastPointerType = event.pointerType || 'touch';

      if (lastPointerType !== 'mouse') {
        beginTouchHold();
      }
    });

    /*
      Keep the inward state alive while the user scrolls
      after starting the touch on the button.
    */
    window.addEventListener('touchmove', function () {
      if (touchHoldActive) {
        keepTouchHoldAlive();
      }
    }, { passive: true, capture: true });

    window.addEventListener('scroll', function () {
      if (touchHoldActive) {
        keepTouchHoldAlive();
      }
    }, { passive: true });

    /*
      Do not exit on touchcancel/pointercancel.
      Mobile scrolling often triggers cancel while the finger is still down.
    */
    window.addEventListener('touchcancel', function () {
      if (touchHoldActive) {
        keepTouchHoldAlive();
      }
    }, { passive: true, capture: true });

    window.addEventListener('pointercancel', function (event) {
      if ((event.pointerType || 'touch') !== 'mouse' && touchHoldActive) {
        keepTouchHoldAlive();
      }
    }, true);

    /*
      Exit the touch hold only after the finger is lifted.
    */
    window.addEventListener('touchend', function () {
      if (touchHoldActive || lastPointerType !== 'mouse') {
        finishTouchHold();
      }
    }, { passive: true, capture: true });

    window.addEventListener('pointerup', function (event) {
      if ((event.pointerType || 'touch') !== 'mouse') {
        finishTouchHold();
      }
    }, true);

    window.addEventListener('blur', function () {
      if (lastPointerType !== 'mouse') {
        touchHoldActive = false;
        clearTimeout(touchHoldFallbackTimer);
        leaveInwardState();
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && lastPointerType !== 'mouse') {
        touchHoldActive = false;
        clearTimeout(touchHoldFallbackTimer);
        leaveInwardState();
      }
    });

    /*
      Click does the final burst and stops the animation.
      On mobile, the tiny delay lets the hover/touch movement appear first.
    */
    host.addEventListener('click', function () {
      if (stopped) return;

      clearTimeout(mobileBurstTimer);

      if (lastPointerType !== 'mouse') {
        mobileBurstTimer = setTimeout(function () {
          burstAndStop();
        }, 220);
      } else {
        burstAndStop();
      }
    });

    startStream('out');
  }

  function getAddToCartTargets() {
    const targets = new Set();

    addToCartSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (element.closest('.shopify-payment-button')) return;

        targets.add(element);
      });
    });

    return targets;
  }

  function getBuyNowTargets() {
    const targets = new Set();

    buyNowSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (element.closest('.atc-bubble-splash')) return;

        if (element.tagName && element.tagName.toLowerCase() === 'iframe') {
          const wrapper = element.closest('.shopify-payment-button');

          if (wrapper) {
            targets.add(wrapper);
          }

          return;
        }

        targets.add(element);
      });
    });

    /*
      Fallback for dynamic checkout buttons rendered as iframes/wrappers.
      If there is no normal button inside, attach the effect to the wrapper.
    */
    document.querySelectorAll('.shopify-payment-button').forEach(function (wrapper) {
      const normalButton = wrapper.querySelector(
        '.shopify-payment-button__button:not(iframe), button, [role="button"]'
      );

      if (!normalButton) {
        targets.add(wrapper);
      }
    });

    return targets;
  }

  function initBubbleSplash() {
    getAddToCartTargets().forEach(function (target) {
      setupBubbleEffect(target, effects.add);
    });

    getBuyNowTargets().forEach(function (target) {
      setupBubbleEffect(target, effects.buy);
    });
  }

  document.addEventListener('DOMContentLoaded', initBubbleSplash);
  document.addEventListener('shopify:section:load', initBubbleSplash);

  const observer = new MutationObserver(initBubbleSplash);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();